import React from "react";

const EXAMPLE_TILES = [
  { label: "Club", hint: "incorrect", tooltip: "What club does the player play for?" },
  { label: "League", hint: "correct", tooltip: "What league does the player play in?" },
  { label: "Country", hint: "correct", tooltip: "What country is the player from?" },
  {
    label: "Position",
    hint: "incorrect",
    tooltip:
      "In what position does the player play (Goalkeeper, Defender, Midfielder, Attacker)?",
  },
  {
    label: "#",
    hint: "partial",
    tooltip:
      "What is the player's number? YELLOW indicates a match within 5 numbers. (ex: #9 & #14)",
  },
  {
    label: "Age",
    hint: "partial",
    tooltip:
      "What is the player's age? YELLOW indicates a match within 2 years. (ex: 19 y/o & 21 y/o)",
  },
];

function HowToPlayModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="htp-overlay" onClick={onClose}>
      <div className="htp-modal" onClick={(e) => e.stopPropagation()}>
        <button
          className="htp-close"
          onClick={onClose}
          aria-label="Close"
        >
          &times;
        </button>

        <h2 className="htp-title">Welcome To Goal Guesser!</h2>

        <div className="htp-body">
          <h3 className="htp-section-heading">How to play:</h3>

          <ul className="htp-rules">
            <li>
              Based on the silhouette, guess who scored the Champions League
              goal within 6 attempts{" "}
              <span className="htp-active-badge">*ACTIVE PLAYERS ONLY*</span>
            </li>
            <li>
              Tiles will change color based on how close your guess is to the
              mystery player
            </li>
          </ul>

          <h3 className="htp-section-heading">Example:</h3>

          <div className="htp-example-row">
            {EXAMPLE_TILES.map(({ label, hint, tooltip }) => (
              <div
                key={label}
                className={`htp-example-tile ${
                  hint === "correct"
                    ? "cell-correct"
                    : hint === "partial"
                      ? "cell-partial"
                      : "cell-incorrect"
                }`}
              >
                {label}
                <span className="tooltip">{tooltip}</span>
              </div>
            ))}
          </div>

          <ul className="htp-rules">
            <li>
              <strong className="htp-green">GREEN</strong> in any tile
              indicates a perfect match
            </li>
            <li>
              Any tile not changing color indicates a non-matching
              characteristic
            </li>
            <li>
              <strong className="htp-yellow">YELLOW</strong> in the # tile
              indicates a match within 5 numbers. (ex: #9 &amp; #14)
            </li>
            <li>
              <strong className="htp-yellow">YELLOW</strong> in the age tile
              indicates a match within 2 years. (ex: 19 y/o &amp; 21 y/o)
            </li>
          </ul>
        </div>

        <button className="htp-close-btn" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}

export default HowToPlayModal;
